// eslint-disable-next-line no-unused-vars
export default function statusFilter(value, statuses) {
  return statuses.find(item => item.userStatusId === value).name
}
